import './style.css';
import "ol/ol.css"
import "ol-ext/dist/ol-ext.css"
import Feature from 'ol/Feature.js';
import Map from 'ol/Map.js';
import View from 'ol/View.js';
import positions from "./houses.json" with { type: "json" };
import Geolocation from 'ol/Geolocation.js';
import Point from 'ol/geom/Point.js';
import TileLayer from 'ol/layer/Tile.js';
import VectorLayer from 'ol/layer/Vector.js';
import OSM from 'ol/source/OSM.js';
import VectorSource from 'ol/source/Vector.js';
import CircleStyle from 'ol/style/Circle.js';
import Icon from 'ol/style/Icon.js';
import Stroke from 'ol/style/Stroke.js';
import Style from 'ol/style/Style.js';
import Fill from 'ol/style/Fill.js';
import Search from 'ol-ext/control/Search.js';
import GeoJSON from 'ol/format/GeoJSON'
import { fromLonLat, transformExtent, transform, toLonLat } from 'ol/proj';  // Correct import
import Openrouteservice from 'openrouteservice-js'
import { Vector } from 'ol/source';
let orsDirections = new Openrouteservice.Directions(
  { host: "http://localhost:8080/ors" }
);


// Define the extent (EPSG:4326) and transform to EPSG:3857
const extent4326 = [43.357, 36.255, 43.395, 36.285];
const center = [43.376798, 36.270699]
const extent3857 = transformExtent(extent4326, 'EPSG:4326', 'EPSG:3857');


const view = new View({
  center: fromLonLat(center),  // Updated center
  zoom: 15,
  minZoom: 15,
  extent: extent3857
})

var map = new Map({
  target: 'map',
  layers: [
    new TileLayer({
      source: new OSM()
    })],
  view: view
});

var markers = new VectorLayer({
  source: new VectorSource(),
  style: new Style({
    image: new Icon({
      anchor: [0.5, 1],
      crossOrigin: 'anonymous',
      src: 'marker-icon.png',
    })
  })
});


var dir_start_markers = new VectorLayer({
  source: new VectorSource(),
  style: new Style({
    image: new Icon({
      color: 'blue',
      anchor: [0.5, 1],
      crossOrigin: 'anonymous',
      src: 'marker-icon.png',
    })
  })
});

map.addLayer(dir_start_markers);

var dir_end_markers = new VectorLayer({
  source: new VectorSource(),
  style: new Style({
    image: new Icon({
      color: 'green',
      anchor: [0.5, 1],
      crossOrigin: 'anonymous',
      src: 'marker-icon.png',
    })
  })
});

map.addLayer(dir_end_markers);


map.addLayer(markers);
// The search control
var search = new Search({
  //target: $(".options").get(0),
  // Title to use in the list
  getTitle: function (f) { return f.name; },
  // Search result
  autocomplete: function (s, cback) {
    var result = [];
    // New search RegExp
    var rex = new RegExp(s.replace("*", "") || "\.*", "i");
    for (var i = 0; i < positions.length; i++) {
      if (rex.test(positions[i].name)) result.push(positions[i]);
    }
    /* Return result directly... */
    return result;
    /* ...or use the callback function
    cback(result);
    return false;
    */
  }
});


const geolocation = new Geolocation({
  // enableHighAccuracy must be set to true to have the heading value.
  trackingOptions: {
    enableHighAccuracy: true,
  },
  projection: view.getProjection(),
});

geolocation.setTracking(true);



const accuracyFeature = new Feature();
geolocation.on('change:accuracyGeometry', function () {
  accuracyFeature.setGeometry(geolocation.getAccuracyGeometry());
});

const positionFeature = new Feature();
positionFeature.setStyle(
  new Style({
    image: new CircleStyle({
      radius: 6,
      fill: new Fill({
        color: '#3399CC',
      }),
      stroke: new Stroke({
        color: '#fff',
        width: 2,
      }),
    }),
  }),
);

// update the HTML page when the position changes.
geolocation.on('change:position', function () {

  const coordinates = geolocation.getPosition();
  positionFeature.setGeometry(coordinates ? new Point(coordinates) : null);
});

map.addControl(search);
search.on('select', async function (e) {
  map.getView().animate({
    center: e.search.pos,
    zoom: 18,
  })
  markers.getSource().clear()
  var marker = new Feature({
    geometry: new Point(e.search.pos)  // Ensure it's a proper OL Point geometry
  });
  markers.getSource().addFeature(marker);

  try {
    let response = await orsDirections.calculate({
      coordinates: [
        toLonLat(positionFeature.getGeometry().getCoordinates()),
        toLonLat(e.search.pos)
      ],
      profile: 'driving-car',
      format: 'geojson'
    });

    console.log("response: ", JSON.stringify(response));

    var vectorLayer = new VectorLayer({
      source: new Vector({
        features: new GeoJSON().readFeatures(response, {
          featureProjection: 'EPSG:3857'
        })
      }),
      style: new Style({
        stroke: new Stroke({
          color: 'red',
          width: 4
        })
      })
    });

    map.addLayer(vectorLayer);
    dir_start_markers.getSource().clear()
    var marker_start = new Feature({
      geometry: new Point(fromLonLat(toLonLat(positionFeature.getGeometry().getCoordinates())))  // Ensure it's a proper OL Point geometry
    });
    dir_start_markers.getSource().addFeature(marker_start);

    dir_end_markers.getSource().clear()
    var marker_start = new Feature({
      geometry: new Point(fromLonLat( toLonLat(e.search.pos)))  // Ensure it's a proper OL Point geometry
    });
    dir_end_markers.getSource().addFeature(marker_start);
    console.log("fef")

  } catch (err) {
    console.log("An error occurred: " + err);
    console.error(await err.response);
  }

});



new VectorLayer({
  map: map,
  source: new VectorSource({
    features: [accuracyFeature, positionFeature],
  }),
});

